module.exports = __webpack_public_path__ + "static/media/camping.e36056e7.png";